<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2010</span></div>
    </div>
    <div class="view-wrap yr2010">


<FullYearStats fullGames='16' fullCompletions='448' fullAttempts='658' fullYards='4,620' fullPct='68.1' fullTDs='33' fullINTs='22' fullYPG='288.8' fullRating='90.9'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">


      <h1 class="content-headline">back-to-back playoff appearances</h1>

      <div class="copy-paragraph">
        In 2010, Brees led the Saints to their second straight playoff appearance as he completed 448-of-658 passes (68.1%) for 4,620 yards with 33 touchdown passes and a 90.9 passer rating.<br/><br/>

        Drew was selected by his teammates as one of five season-long captains, starting all 16 regular season games and the NFC Wild Card playoff contest. He completed 448-of-658 (68.1%) passes for 4,620 yards with 33 touchdown passes and a 90.8 passer rating. Brees was the first Saint to be selected to three consecutive Pro Bowls since WR Joe Horn (2000-02).<br/><br/>

        Brees and the Saints followed up their magical run from the year before with another very strong season, finishing the regular season 11-5. Unfortunately, the Saints’ dreams of repeating as Super Bowl Champs were dashed in Seattle after a Wild Card Round upset at the hands of Marshawn Lynch and the Seahawks.<br/><br/>

        Drew finished first in the NFL in completion percentage, second in completions, tied for second in scoring passes, and ranked third in yardage.

      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2010-img-in-copy.jpg')" style="width:100%;" alt="Drew Brees and Roman Harper dap fists after a big play">
      </div>


<div class="awards-wrapper">
        <div class="awards-headline">2010 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2010 Pro Bowl</li>
          <li><img :src="require('@/assets/si-award.jpg')" alt="Sports Illustrated Logo"> SI Sportsman of the Year</li>
          <li><img :src="require('@/assets/ap-award.jpg')" alt="AP Logo"> AP Male Athlete of the Year</li>
          <li><img :src="require('@/assets/sn-logo.png')" alt="Sporting News Logo"> SN 100 Greatest Players (No. 2)</li>
          <li><img :src="require('@/assets/pfwa-award.jpg')" alt="Pfo Football Writers of America Logo"> PFWA Good Guy Award (For 2009 NFL season)</li>
          
          
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 


      </div> <!--end text-flex-->
    </div>
  </div>

 <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2010 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>



<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2010 Touchdown Tally"> 2010 TOUCHDOWN TALLY</h1>
</div>





</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2010 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2010 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2010 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2010 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2010 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2010 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2010 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2010 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2009">«2009</router-link></div>
  <div class="year-pagination-section year-pagination-current">2010</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2011">2011»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue';

import axios from 'axios';

export default {
  name: 'yr2010',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2010 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2010-top.jpg",
      image1: "brees-2010-slide-1.jpg",
      image2: "brees-2010-slide-2.jpg",
      image3: "brees-2010-slide-3.jpg",
      image4: "brees-2010-slide-4.jpg",
      image5: "brees-2010-slide-5.jpg",
      image6: "brees-2010-slide-6.jpg",
      image7: "brees-2010-slide-7.jpg",
      image8: "brees-2010-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2010;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },
 mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 68.1,
                  y: 4620,
                  r: 33/1.5
                }
              ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.9,
                  y: 3900,
                  r: 36/1.5
                }
              ]
      },
      {
        "label": "Phillip Rivers",
        "backgroundColor": "#0080C6",
        "borderColor": "#FFC20E",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 66.0,
                  y: 4710,
                  r: 30/1.5
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.7,
                  y: 3922,
                  r: 28/1.5
                }
              ]
      },
       {
        "label": "Ben Roethlisberger",
        "backgroundColor": "#FFB612",
        "borderColor": "#101820",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 61.7,
                  y: 3200,
                  r: 17/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + tooltipItem.xLabel.toLocaleString() + ' Completion %, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2010.vue